<template>
  <b-table
    :loading="isLoading"
    :paginated="paginated"
    :per-page="perPage"
    :striped="isStriped"
    :hoverable="hoverable"
    default-sort="name"
    :data="results"
    slot="content"
  >
    <template slot-scope="props">
      <b-table-column label="Lección" field="lesson" sortable>
        <lesson-pdf-button :lesson-id="props.row.lesson.id" :text="props.row.lesson.name"/>
      </b-table-column>
      <b-table-column label="Fecha Inicio" field="startDate">{{ moment(props.row.start_date, 'YYYY-MM-DD') | moment('LL')}}</b-table-column>
      <b-table-column label="Fecha Termino" field="finishDate">{{ props.row.end_date ? moment(props.row.end_date, 'YYYY-MM-DD').format('LL') : 'En curso'}}</b-table-column>
    </template>

    <section class="section" slot="empty">
      <div class="content has-text-grey has-text-centered">
        <template v-if="isLoading">
          <p>
            <b-icon icon="dots-horizontal" size="is-large" />
          </p>
          <p>Cargando Resultados...</p>
        </template>
        <template v-else>
          <p>
            <b-icon icon="horseshoe" size="is-large" />
          </p>
          <p>No hay Resultados&hellip;</p>
        </template>
      </div>
    </section>
  </b-table>
</template>

<script>
import TenantService from '@/services/TenantService'
import LessonPdfButton from '@/components/LessonPDFButton'

export default {
  components: {
    LessonPdfButton
  },
  props: {
    horseId: {
      required: true
    }
  },
  created () {
    this.getHistory()
  },
  data () {
    return {
      results: [],
      paginated: true,
      perPage: 10,
      isStriped: true,
      hoverable: true,
      isLoading: false,
      numberResult: 0
    }
  },
  methods: {
    async getHistory () {
      this.isLoading = true
      let params = {
        'include[0]': 'lesson',
        'horse_id': this.horseId
      }
      let response = await TenantService.getHistoryLesson(params)
      this.results = response.data.data
      this.numberResult = this.results.length
      this.isLoading = false
    }
  },
  watch: {
    horseId (value) {
      this.getHistory()
    },
    numberResult (value) {
      this.$emit('number-result-changed', value)
    }
  }
}
</script>
